import { Tooltip, PopoverPosition } from "construct-ui";
import ViewBase from "../../../../view-base.view";
import SingleSelectComponent from "../../../../../components/single-select/single-select.component";
import DatePickerComponent from "../../../../../components/date-picker/date-picker.component";
import moment from 'moment';
import campaignModel from "../../../../../models/planogram/campaign.model"
import codeMasterModel from "../../../../../models/common/code-master.model";
import { formats as FORMATS, codeMasterType } from "../../../../../config/constants";

export default function Step1() {
  ViewBase.call(this);
  let planogramTypeList = [];
  let _campaignId = '';
  let statuses = [];
  let onGoNext = () => { };
  let _campaignViewState = {};

  const inputDataModel = {
    planogramType: '',
    campaignName: '',
    campaignDescription: '',
    status: "1",
    campaignStartDate: '',
    campaignEndDate: ''
  };

  const getPlanogramTypes = () => {
    codeMasterModel.getByCategoryV2({ category: codeMasterType.planogramType })
      .then(result => {
        planogramTypeList = result
      })
      .catch(error => {
        this.handleError(error)
      })
  }

  const getByCampaignId = (campaignId) => {
    campaignModel.getCampaignById(campaignId).then((result) => {
      generateObject(result);
    }).catch((error) => {
      this.handleError(error);
    })
  }

  const generateObject = (result) => {
    inputDataModel.planogramType = result.planogramType;
    inputDataModel.campaignName = result.campaignName;
    inputDataModel.campaignDescription = result.description;
    inputDataModel.campaignStartDate = moment(result.periodStart).format(FORMATS.dateFormat);
    inputDataModel.campaignEndDate = moment(result.periodEnd).format(FORMATS.dateFormat);
  }

  const getStatuses = () => {
    codeMasterModel.getByCategoryV2({ category: 'CommonStatus' })
      .then((result) => {
        statuses = result
      })
      .catch((error) => {
        this.handleError(error);
      })
  }

  const onTitleChange = (e) => {
    inputDataModel.campaignName = e.target.value;
  }

  const onDescChange = (e) => {
    inputDataModel.campaignDescription = e.target.value;
  }

  const handleSave = (e) => {
    if (!this.validateForm(e, "#createCampaign")) {
      return false;
    } else {
      const paramsObj = structuredClone(inputDataModel)

      paramsObj.planogramType = paramsObj.planogramType;
      paramsObj.campaignName = paramsObj.campaignName;
      paramsObj.campaignDescription = paramsObj.campaignDescription;
      paramsObj.status = Number(paramsObj.status);
      paramsObj.campaignStartDate = moment(paramsObj.campaignStartDate).format(FORMATS.apiDateFormat);
      paramsObj.campaignEndDate = moment(paramsObj.campaignEndDate).format(FORMATS.apiDateFormat);
      if (_campaignId) {
        paramsObj.campaignId = _campaignId;
      }
      campaignModel.createCampaign(paramsObj).then((result) => {
        if (result.campaignID) {
          _campaignViewState.clearState();
          onGoNext(result);
        } else {
          this.showErrorMessage(this.getText(result.code, result.name));
        }

      }).catch((error) => {
        this.handleError(error);
      })
    }

  };

  return {
    oninit: ({ attrs: { onNext, campaignId, campaignViewState } }) => {
      if (onNext) {
        onGoNext = onNext;
      }
      getPlanogramTypes();
      getStatuses();
      if (campaignId) {
        _campaignId = campaignId;
        getByCampaignId(campaignId);
      }
      if (campaignViewState) {
				_campaignViewState = campaignViewState
			}
    },
    view: (vnode) => {
      return [
        m("form#createCampaign.row.g-3.needs-validation[novalidate]",
          {
            onsubmit: handleSave
          },
          m('.row.g-3',
            m('.col-md-4.position-relative',
              m('label.form-label.mandatory[for=planogramType]', this.getText("LT00001198", "Image Type")),
              m(SingleSelectComponent, {
                id: 'planogramType',
                required: true,
                items: planogramTypeList,
                allowEmpty: false,
                keyOnly: true,
                selectedItem: inputDataModel.planogramType,
                onSelect: (selectedItem) => {
                  inputDataModel.planogramType = selectedItem
                }
              }),
              m('.invalid-tooltip', this.getText("LT00000201", "Please select")),
            ),
            m('.col-md-4.position-relative',
              m('label.form-label.mandatory[for="campaign"]', this.getText("LT00001201", "Campaign"), m(Tooltip, {
                content: m('p',
                  m('p', m('strong', "Please note that the combination of Image Type and Campaign Name must be "), m('b', m("mark", "unique")), "!"),
                  m('p', m('em', "For Example: " )),
                  m('p', m('b', "Planogram + Campaign 1 "), "and ",
                   m("b", "POP Compliance + Campaign 1"), " are valid. "),
                  m('p', "but ", m('b', "Planogram + Campaign 1 "), "and  ", m('b', "Planogram + Campaign 1 "), " are not allowed.")
                ),
                style: {width: '400px'},
                hoverOpenDelay: 250,
                openOnTriggerFocus: true,
                position: PopoverPosition.RIGHT,
                trigger: m('i.bi.bi-info-circle.cursor-pointer.ps-1.me-0', { style: { 'color': '#FF9800' } })
              })),
              m('input#campaign[required][type=text][placeholder=' +
                this.getText("LT00001201", "Campaign") + '][value="' + inputDataModel.campaignName + '"] .form-control.form-control-bg', { maxlength: 100, onchange: onTitleChange }
              ),
              m('.invalid-tooltip', this.getText("EM00000829", "Please input")),
            ),
            m('.col-md-4.position-relative',
              m('label.form-label.mandatory[for=status]', this.getText("LT00000015", "Status")),
              m(SingleSelectComponent, {
                id: 'status',
                required: true,
                items: statuses,
                allowEmpty: false,
                keyOnly: true,
                selectedItem: inputDataModel.status,
                onSelect: (selectedItem) => {
                  inputDataModel.status = selectedItem
                }
              }),
              m('.invalid-tooltip', this.getText("LT00000201", "Please select")),
            ),
            m('.col-md-4.position-relative',
              m('label.form-label.mandatory[for="datePicker"]', this.getText('LT00000150', 'Period')),
              m(DatePickerComponent, {
                id: 'datePicker',
                class: 'form-control',
                placeholder: this.getText('LT00000895', 'Time Range'),
                isRange: true,
                required: true,
                dateStart: inputDataModel.campaignStartDate,
                dateEnd: inputDataModel.campaignEndDate,
                onselect: (event) => {
                  inputDataModel.campaignStartDate = event.detail.start;
                  inputDataModel.campaignEndDate = event.detail.end;
                }
              }),
              m('.invalid-tooltip', this.getText("LT00000201", "Please select")),
            ),
            m('.col-md-4.position-relative',
              m('label.form-label[for=campaignDescription]', this.getText("LT00000012", "Description")),
              m('textarea#campaignDescription.form-control.form-control-bg',
                {
                  onchange: onDescChange,
                  placeholder: this.getText("LT00000012", "Description"),
                },
                inputDataModel.campaignDescription
              ),
            ),
          ),
          m('.row',
            m('.col-md-12.gap-2.mt-4.d-flex.justify-content-center',
              m('button.btn.btn-primary[type="submit"].px-4.gap-3', this.getText('LT00001204', "Save & Next")),
            )
          )
        ),
        this.getBaseViews()
      ]
    }
  }
}